export default __webpack_public_path__ + "static/durss_box-77549afd240955a20d47906b4f6f080c.jpg";